import React, { useEffect } from "react";
import "./FooterPage.css";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { storeCategories } from "../../home/redux/actions";
import { maintainStoretype } from "../../home/redux/actions";
import { useNavigate } from "react-router-dom";
import facebook from "../../../assets/facebook.svg";
import instagram from "../../../assets/instagram.svg";
import { Container, Row } from "react-bootstrap";
import { acceptCookies } from "../../home/redux/actions";

function FooterPage(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const socialMediaicons = [
    {
      image: facebook,
      className: "facebook",
    },
    {
      image: instagram,
      className: "instagram",
    },
   ];
  const useFultext = [
      {
        type:"aboutus",
        text:"pages.footer.aboutus"
      },{
        type:"terms",
        text:"pages.footer.terms"
      },{
        type:"privacy",
        text:"pages.footer.privacy"
      },{
          type:"faqs",
          text:"pages.footer.faqs"
      },{
          type:"return",
          text:"pages.footer.return"
       },{
          type:"policies",
          text:"pages.Shipping Policies"
       },{
          type:"contactus",
          text:"pages.footer.contactus"
       },{
        type:"sitemap",
        text:"pages.footer.sitemap"
     }
  ]

  useEffect(() => {
    console.log("Footer page");
  }, []);

  const selectCategory = (id, storetype) => {
    let getCategories = [];
    props.categories.forEach((item, index) => {
      if (item.id === id) {
        props.categories[index].is_checked = true;
      } else {
        props.categories[index].is_checked = false;
      }
      getCategories.push(props.categories[index]);
    });
    props.storeCategories(getCategories);
    props.maintainStoretype(storetype);
    var timestamp = new Date().getTime();
    navigate("/stores/"+id, { state: { obj: timestamp } });
  };
 
  const navigatePage = (type) => {
    switch (type) {
      case "aboutus":
        navigate("/pages/about-us");
        break;
        case "terms":
        navigate("/pages/terms-conditions");
        break;
        case "privacy":
          navigate("/pages/privacy-policy");
        break;
        case "faqs":
          navigate("/pages/faqs");
        break;
        case "return":
          navigate("/pages/return-policy");
        break;
        case "policies":
          navigate("/pages/shipping-policy");
          break;
        case "contactus":
          navigate("/pages/contact-us");
          break;
        case "sitemap":
          navigate("/pages/site-map");
        break;
       default:
        break;
    }
  }

  const acceptCookie = (e) => {
    e.preventDefault();
    props.acceptCookies("yes");
  };

  const FooterList = ({title,list,type}) => {
       return (
        <div className="col Categories" key={title.toString()}>
        <div className="flex">
          <strong>{t(title)} </strong>
        </div>
        {list?.map(
          (item, index) =>
          <React.Fragment key={index?.toString()}>
            {type === "" ? (
              <span  onClick={() => navigatePage(item?.type)}>
                - {t(item?.text)}
               </span>
            ):(
              item.type === type && (
                <span
                onClick={() => selectCategory(item.id, type)}
              >
                - {item?.title}
              </span>
              )
            )}
          </React.Fragment>
        )
        }
      </div>
       )
  }

  const navigateTosocial = (item) => {
    switch (item) {
      case "facebook":
        window.open("https://www.facebook.com/girnecom","_blank");
        break;
      case "instagram":
        window.open("https://www.instagram.com/girnecom/","_blank");
        break;
      default:
        break;
    }
}

  return (
    <>
      <aside id="footer">
        <div className="hr"></div>
        <footer>
          <div className="container">
            <div className="row aboutinfo secound-footer">
              {<FooterList title = "pages.footer.categories" list={props?.categories} type="goods"/>}
              {<FooterList title = "pages.Services" list={props?.categories} type="service"/>}
              {<FooterList title = "pages.footer.links" list={useFultext} type=""/>}
              <div className="col needhelp">
                <div className="flex">
                  <strong>{t("pages.footer.needhelp")}</strong>
                </div>
                <h4 className="h4">
                  <a href="tel:+90 500-130-0001">+90 533 423 50 50</a>
                </h4>
                <h6 className="h6">
                  <a href="mailto:info@girne.com">info@girne.com</a>
                </h6>
                 <div className="social">
                  {socialMediaicons.map((item, index) => (
                    <i key={index?.toString()} onClick={()=>navigateTosocial(item.className)} className={"social_icon icon_after white "+item.className} />
                  ))}
                </div> 
              </div>
            </div>
          </div>
        </footer>
        <hr className="hrs" />
        <div className="rights">
          <center>
            {t("pages.footer.coryright")} © {new Date().getFullYear()}{" "}
            <span className="primary">Girne.com</span>.{" "}
            {t("pages.footer.allrights")}
          </center>
        </div>
      </aside>
      {props.acceptcookies !== "yes" && (
        <div className="cookies">
          <Container>
            <Row className="align-items-center">
              <div className="col-sm-12 col-md-8 col-lg-8 col-xl-8 pt-4 pb-4">
                <h5>{t("pages.cookies.title")}</h5>
                <p>{t("pages.cookies.text")}</p>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                <button
                  type="submit"
                  style={{
                    lineHeight: "1.4",
                    fontFamily: "amazon_embermedium",
                    whiteSpace: "nowrap",
                    fontSize: "14px",
                  }}
                  className="btn-submit m-2 hover-btn"
                  onClick={(e) => acceptCookie(e)}
                >
                  {t("pages.cookies.accept")}
                </button>
              </div>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  categories: state?.home?.categories,
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
  acceptcookies: state?.home?.acceptcookies,
});

export default connect(mapStateToProps, {
  storeCategories,
  maintainStoretype,
  acceptCookies,
})(FooterPage);
